if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.fakeSubmitButton = document.querySelector(".fake-checkout-button");
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.autoScrollToReviews();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.changeSubmitButtonDesign(this.submitButton, "loading");
        this.changeSubmitButtonDesign(this.fakeSubmitButton, "loading");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              this.changeSubmitButtonDesign(this.submitButton, "soldout");
              this.changeSubmitButtonDesign(this.fakeSubmitButton, "soldout");

              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.changeSubmitButtonDesign(this.submitButton, "clear");
            this.changeSubmitButtonDesign(this.fakeSubmitButton, "clear");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          });
      }

      /**
       *
       * @param {HTMLElement} element
       * @param {String} action ['loading', 'soldout', 'clear']
       * @returns
       */
      changeSubmitButtonDesign(element, action = "loading") {
        if (element == null) return null;

        if (action === "loading") {
          element.setAttribute("aria-disabled", true);
          element.classList.add("loading");
          element
            .querySelector(".loading-overlay__spinner")
            .classList.remove("hidden");
          return;
        }

        if (action === "soldout") {
          const soldOutMessage = element.querySelector(".sold-out-message");
          if (!soldOutMessage) return;
          element.setAttribute("aria-disabled", true);
          element.querySelector("span").classList.add("hidden");
          soldOutMessage.classList.remove("hidden");

          return;
        }

        // clear
        element.classList.remove("loading");
        if (!this.error) element.removeAttribute("aria-disabled");
        element
          .querySelector(".loading-overlay__spinner")
          .classList.add("hidden");
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      autoScrollToReviews() {
        const urlParams = new URLSearchParams(window.location.search);

        console.log("a");
        if (!urlParams.has("scroll-to-reviews")) return null;
        console.log("b");
        const doTheScroll = () => {
          const allReviewsElement = document.querySelector(
            ".reviews_all_container"
          );
          console.log("c", allReviewsElement);
          if (!allReviewsElement) return;

          autoScrollElementTop(allReviewsElement);
        };

        // wait for the customizer app block to render klaviyo all reviews
        setTimeout(() => {
          console.log("gg", document.querySelector(".reviews_all_container"));
          doTheScroll();
          console.log("timeout");
        }, 3000);
      }
    }
  );
}

function autoScrollElementTop(element, offset = 150) {
  if (element != null) {
    const position = element.getBoundingClientRect();
    window.scroll({
      top: position.top + window.scrollY - offset,
      left: 0,
      behavior: "smooth",
    });
  }
}
